export const getters = {
    getContactMessage: state => state.contactMessage
}